import type { RunStatus, TaskStatus } from "@/modules/bugfix-agent/lib/shared/types"

export const STATUS_STYLE: Record<TaskStatus, { dot: string; badge: string; column: string; ring: string }> = {
  request: { dot: "bg-slate-400", badge: "bg-slate-100 text-slate-700", column: "bg-slate-50/80", ring: "ring-slate-300" },
  in_progress: { dot: "bg-blue-500", badge: "bg-blue-100 text-blue-700", column: "bg-blue-50/50", ring: "ring-blue-300" },
  needs_attention: { dot: "bg-amber-500", badge: "bg-amber-100 text-amber-800", column: "bg-amber-50/60", ring: "ring-amber-300" },
  rework: { dot: "bg-rose-500", badge: "bg-rose-100 text-rose-700", column: "bg-rose-50/50", ring: "ring-rose-300" },
  review: { dot: "bg-violet-500", badge: "bg-violet-100 text-violet-700", column: "bg-violet-50/50", ring: "ring-violet-300" },
  awaiting_merge: { dot: "bg-cyan-500", badge: "bg-cyan-100 text-cyan-800", column: "bg-cyan-50/50", ring: "ring-cyan-300" },
  merged: { dot: "bg-emerald-500", badge: "bg-emerald-100 text-emerald-700", column: "bg-emerald-50/50", ring: "ring-emerald-300" },
  paused: { dot: "bg-stone-400", badge: "bg-stone-200 text-stone-700", column: "bg-stone-100/80", ring: "ring-stone-300" },
}

export const RUN_LABELS: Record<RunStatus, string> = {
  CREATING: "запускается",
  RUNNING: "работает",
  FINISHED: "шаг завершён",
  ERROR: "ошибка",
  CANCELLED: "остановлен",
  EXPIRED: "истёк",
}

export const AGENT_STATE_LABELS: Record<RunStatus, string> = {
  CREATING: "Агент запускается",
  RUNNING: "Агент работает",
  FINISHED: "Агент закончил шаг",
  ERROR: "Агент: ошибка",
  CANCELLED: "Агент остановлен",
  EXPIRED: "Агент: время истекло",
}

export const isRunActive = (s: RunStatus | null | undefined) => s === "CREATING" || s === "RUNNING"

export function relativeTime(iso: string): string {
  const diff = Date.now() - Date.parse(iso)
  const min = Math.round(diff / 60000)
  if (min < 1) return "только что"
  if (min < 60) return `${min} мин назад`
  const h = Math.round(min / 60)
  if (h < 24) return `${h} ч назад`
  return new Date(iso).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
}

export function formatSize(n: number): string {
  if (n >= 1024 * 1024 * 1024) return `${(n / 1024 / 1024 / 1024).toFixed(1)} ГБ`
  if (n >= 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} МБ`
  return `${Math.max(1, Math.round(n / 1024))} КБ`
}
